<template>
  <div class="row q-col-gutter-y-lg q-pb-md">
    <div class="col-12">
      <common-input
          v-model="form.first_name"
          label="Voornaam"
          name="first_name"
          auto-complete="given-name"
          :error-message="$errorMessage('first_name')"
          :error="$hasError('first_name')"
          required
          autofocus
      />
    </div>
    <div class="col-12">
      <common-input
          v-model="form.last_name"
          label="Achternaam"
          name="last_name"
          auto-complete="family-name"
          :error-message="$errorMessage('last_name')"
          :error="$hasError('last_name')"
          required
      />
    </div>
    <div class="col-12">
      <common-input
          v-model="form.password"
          label="Wachtwoord"
          :type="hidePassword ? 'password' : 'text'"
          name="password"
          :error-message="$errorMessage('password')"
          :error="$hasError('password')"
          required
      >
        <template v-slot:append>
          <q-btn flat
                 dense
                 round
                 :icon="hidePassword ? 'visibility_off' : 'visibility'"
                 :aria-label="hidePassword ? 'Toon wachtwoord' : 'Verberg wachtwoord' "
                 @click="hidePassword = !hidePassword"
          />
        </template>
      </common-input>
    </div>
    <div class="col-12">
      <common-input
          v-model="form.password_repeat"
          label="Herhaal wachtwoord"
          :type="hideRepeat ? 'password' : 'text'"
          name="password_repeat"
          :error-message="$errorMessage('password_repeat')"
          :error="$hasError('password_repeat')"
          required
      >
        <template v-slot:append>
          <q-btn flat
                 dense
                 round
                 :icon="hideRepeat ? 'visibility_off' : 'visibility'"
                 :aria-label="hideRepeat ? 'Toon wachtwoord' : 'Verberg wachtwoord' "
                 @click="hideRepeat = !hideRepeat"
          />
        </template>
      </common-input>
    </div>
    <div class="col-12">
      <common-input
          v-model="form.phone_number"
          label="Telefoonnummer"
          type="tel"
          name="phone_number"
          auto-complete="tel"
          :error-message="$errorMessage('phone_number')"
          :error="$hasError('phone_number')"
      />
    </div>
    <div class="col-12">
      <common-input
          v-model="form.email"
          label="E-mailadres"
          type="email"
          name="email"
          auto-complete="email"
          :error-message="$errorMessage('email')"
          :error="$hasError('email')"
          required
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hidePassword: true,
      hideRepeat: true,
      form: {
        first_name: this.$old('first_name'),
        last_name: this.$old('last_name'),
        password: '',
        password_repeat: '',
        phone_number: this.$old('phone_number'),
        email: this.$old('email'),
      },
    }
  }
}
</script>
